import { render } from "./SideView.vue?vue&type=template&id=078ec7cd"
import script from "./SideView.vue?vue&type=script&lang=js"
export * from "./SideView.vue?vue&type=script&lang=js"

import "./SideView.vue?vue&type=style&index=0&id=078ec7cd&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__